import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { BENEFIT_DELETE_ENTITY } from "../constants/planCreation.constants";
import { useRequestState } from "./useRequestState";
var REQUEST_KEY = "deletePlanCreationBenefit";
export var useDeletePlanBenefit = function () {
    var dispatch = useDispatch();
    var _a = useRequestState(REQUEST_KEY), data = _a.data, loading = _a.loading, error = _a.error;
    var deleteBenefit = function (_a) {
        var id = _a.id, userId = _a.userId;
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/delete/".concat(BENEFIT_DELETE_ENTITY, "/").concat(id, "/user-mod/").concat(userId),
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        deleteBenefit: deleteBenefit,
        benefitDeleted: data,
        loading: loading,
        error: error,
        clearDeleted: function () { return dispatch(clearCustomRequest(REQUEST_KEY)); },
    };
};
